import React from 'react'
import { Link } from 'gatsby'
import PropTypes from 'prop-types'

const LinkComponent = ({ url, children, tag = 'a', ...rest }) => {
  //Use Gatsby Link component for internal links (links starting with /), otherwise whatever is passed as tag-prop (defaults to <a>)
  const internal = /^\/(?!\/)/.test(url) && rest?.target !== '_blank'
  const Tag = internal ? Link : tag

  return (
    <Tag {...(internal ? { to: url } : { href: url })} {...rest}>
      {children}
    </Tag>
  )
}

LinkComponent.propTypes = {
  url: PropTypes.string,
  children: PropTypes.node,
  tag: PropTypes.oneOf(['a', 'button']),
}

export default LinkComponent
